/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {  
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      $.getJSON('/cart.js', function(cart) {
        saveCartSession(cart);
      });
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {  
  $(document.body).trigger('beforeGetCart.ajaxCart');
  
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);      
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
    
    //$("#AddToCart").attr("disabled", false);
    
    $('#AddToCartText').html('Add to Order');
 
    
    $('#AddToCart').removeClass('cls-ajax-load');
	
  });
  
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      saveCartSession(cart);
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer, $viewBtn;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    $viewBtn = $(settings.viewBtn);
    
    $cartContainer.append($viewBtn);
    
    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
    
    $cartContainer.on('click', '#quick-cart', function(){
      if($('html').hasClass('js-drawer-open')) {
        if(timber.RightDrawer) {
          timber.RightDrawer.close();
        }
      } else {
        loadCart();
      }
      
    });
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {    
    $('.cart-count').text(cart.item_count);
       
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
      
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price    
    updateCountPrice(cart);
    buildCart(cart);    
  };

  buildCart = function (cart) {
    $('.cart-count').text(cart.item_count);
        
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p>' + "No items in your cart" + '</p>');
      cartCallback(cart);
      return;
    }
    
    
    if(customerTags != '') {
      var customerTagsArray = customerTags.split(",");
    } else {
      var customerTagsArray = '';
    }
    

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source),
        subTotal = 0;

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      //console.log(cartItem);
      

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      /*var productUrl = '/products/' + cartItem.handle + '.js';
      
      var _tags = [];
      
      $.ajax({
                  type: 'GET',
                  url: productUrl,
                  dataType: 'json',
                  async: false,
                  cache: false,                  
                  success: function (responseData) {
                    _tags = pushArray(_tags, responseData.tags);
                  },
                  error: function () {
                    
                  }
              });
      
      */
     	//var rawprice = Shopify.formatMoney(cartItem.price, settings.moneyFormat);
      	//var itemDiscount = 0;
        //var maxDiscount = 0;
        
      	//alert(productTags);
      
      //customerTags 
      
      //console.log(_tags);
      	
      //var _price = cartItem.price;
      //var _rawprice = _price / 100;
      //var _itemDiscount = 0;

      var  _maxDiscount = 0;
      var _discountPrice = getDiscountPrice(cartItem, _maxDiscount, index);
      var itemPrice = Number(cartItem.final_price);;
      
      $.each(cartItem.properties, function(name, value) {
          	if(name == '_yelp_custom_price' && value != '') {
              itemPrice = value;
            }
        });
           
      var linePrice = itemPrice*cartItem.quantity;
      subTotal += linePrice;
      
        /*$.each(productTags, function(index, tag) {
          	if(tag.indexOf('*net-') != -1){
                //alert('found');
            }
        });*/
      
      //console.log(subTotal);
      
      //var tempCartItemProperties = cartItem.properties;
      //console.log(tempCartItemProperties);
      
      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: remove_underscore(cartItem.properties),
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(itemPrice, settings.moneyFormat), //Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        maxDiscount: _maxDiscount,
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(linePrice, settings.moneyFormat), //Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
        isBundle: cartItem.properties.th_bundle_type,
        _swatchImg: cartItem.properties._Swatch
      };
      

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(subTotal, settings.moneyFormat),//Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }
    
    $('.cart-subtotal').text(data.totalPrice);

    $cartContainer.append(template(data));
    $cartContainer.append($viewBtn);
    
    cartCallback(cart);
  };

  cartCallback = function(cart) {
    if(cart.item_count === 0) {
      if(timber.RightDrawer) {
        timber.RightDrawer.close();
      }
      	
      	$('#quick-cart').addClass('hide-quick-cart');
      	$('.cart-subtotal').text('$0.00');
      	
    } else {
    	$('#quick-cart').removeClass('hide-quick-cart');
      
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
    }
    
    
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));



function pushArray(list, other) {
    var len = other.length;
    var start = list.length;
    list.length = start + len;
    for (var i = 0; i < len; i++ , start++) {
        list[start] = other[i];
    }
  
  return list;
}


function getDiscountPrice(item, discount, ind) {
  var rowItemPrice = Number(item.final_price);
  var rowToltaPrice = rowItemPrice * item.quantity;
  var boldVPrice = item.properties._boldVariantPrices ? item.properties._boldVariantPrices.split(',') : 0;
  var boldVQtys = item.properties._boldVariantQtys ? item.properties._boldVariantQtys.split(',') : 0;
  var boldItemPrice = 0;
  var boldTotalPrice = 0;
  var allProperties = item.properties;
  
  var _boldVariantPricesNew = '';
  var _boldVariantQtysNew = '';
  
  if(boldVQtys) {
    for(var k=0; k<boldVQtys.length; k++) {
      var qt = boldVQtys[k].indexOf('*') === -1 ? item.quantity : parseInt(boldVQtys[k]);
      
      boldItemPrice += 1 * Number(boldVPrice[k]);
      boldTotalPrice += qt * Number(boldVPrice[k]);
      
      _boldVariantPricesNew += (_boldVariantPricesNew ? ',' : '') + boldVPrice[k];
      _boldVariantQtysNew += (_boldVariantQtysNew ? ',' : '') + (boldVQtys[k].indexOf('*') === -1 ? qt : (qt + '*'));
    }
    
    console.log('_boldVariantPrices: ' + item.properties._boldVariantPrices);
    console.log('_boldVariantQtys: ' + item.properties._boldVariantQtys);
    console.log('_boldVariantPricesNew: ' + _boldVariantPricesNew);
    console.log('_boldVariantQtysNew: ' + _boldVariantQtysNew);

    if(_boldVariantQtysNew !== item.properties._boldVariantQtys) {
      allProperties._boldVariantQtys = _boldVariantQtysNew;
      /*$.ajax({
          type: 'POST',
          url: '/cart/change.js',
          dataType: 'json',
          data: {
              quantity: item.quantity,
              id: item.variant_id,
              properties: {
                _boldVariantQtys: _boldVariantQtysNew
              }
          },
          success: function(cart) {
              console.log(cart);
          },
          error: function(response) {
              alert(response);
          }
      });*/
      jQuery.post('/cart/change.js', {
        line: (ind + 1),
        quantity: item.quantity,
        properties: allProperties
      });
    }
    
  } else if(boldVPrice && boldVPrice.length) {
    boldItemPrice = Number(boldVPrice[0]);
    boldTotalPrice = Number(boldVPrice[0]) * item.quantity;
    
  }
  
  
  
  rowItemPrice = rowItemPrice + boldItemPrice;
  rowItemPrice = ((rowItemPrice - (rowItemPrice * discount))/100)*100;
  
  rowToltaPrice = rowToltaPrice + boldTotalPrice;
  rowToltaPrice = ((rowToltaPrice - (rowToltaPrice * discount))/100)*100;

  /*var boldItemPrice = boldVQtys ? (boldVQtys * Number(boldVPrice)) : splitAndTotal(false, boldVPrice);
    var boldTotalPrice = boldVQtys ? (boldVQtys * Number(boldVPrice)) : splitAndTotal(item.quantity, boldVPrice);

    rowItemPrice = rowItemPrice + boldItemPrice;
    rowItemPrice = ((rowItemPrice - (rowItemPrice * discount))/100)*100;

    rowToltaPrice = rowToltaPrice + boldTotalPrice;
    rowToltaPrice = ((rowToltaPrice - (rowToltaPrice * discount))/100)*100;*/
  
  console.log(rowItemPrice+'->'+rowToltaPrice);
  
  return {
    rowItemPrice: rowItemPrice,
    rowToltaPrice: rowToltaPrice    
  }
}

function remove_underscore(_obj){
  var _returnObj = {};
  
  for(var _o in _obj) {
    if((_o[0] !== '_')) {
      _returnObj[_o] = _obj[_o];
    }
    //_returnObj[(_o[0] == '_') ? _o.substr(1) : _o] = _obj[_o];
  }
  
  return _returnObj;
}

$("#AddToCart").click(function() {
    $('#AddToCart').addClass('cls-ajax-load');
    $('#AddToCartText').html('Adding...');
    //$("#AddToCart").attr("disabled", true);
});

function cartValidation(callback) {
 	jQuery.getJSON('/cart.js', function (cart) {
      var sampleItemInCart = false;

       if(cart.item_count > 0) {
         $.each(cart.items, function (itemkey, itemvalue) {
           $.each(itemvalue.properties, function (propertykey, propertyvalue) {
             if(propertykey == '_sample') {
               sampleItemInCart = true;
               return false;
             }
           });
         });
       }

      if(sampleItemInCart === true) {
        callback(true);
      } else {
        callback(false);
      }
 }); 
}